import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'
import CommandPalette from './CommandPalette'

const Layout = ({ userRole = 'client', children }) => {
  const [collapsed, setCollapsed] = useState(false)
  const location = useLocation()

  // Full-screen routes — hide sidebar, header, and scroll padding
  const isEditorRoute =
    location.pathname.includes('/admin/editor') ||
    location.pathname.includes('/admin/neweditor') ||
    location.pathname.includes('/client/editor') ||
    location.pathname.includes('/preview')

  return (
    <div className="app-shell">

      {/* Sidebar — hidden on editor routes */}
      {!isEditorRoute && (
        <Sidebar
          collapsed={collapsed}
          onCollapse={() => setCollapsed(c => !c)}
        />
      )}

      {/* Main area — span full width on editor routes (no sidebar present) */}
      <div className="main-area" style={isEditorRoute ? { gridColumn: '1 / -1' } : undefined}>

        {/* Topbar — hidden on editor routes */}
        {!isEditorRoute && <Header />}

        {/* Page content */}
        {isEditorRoute ? (
          <div style={{ height: '100%' }}>
            {children || <Outlet />}
          </div>
        ) : (
          <div className="page-scroll">
            {children || <Outlet />}
          </div>
        )}

      </div>

      {/* Command Palette — always mounted, renders nothing when closed */}
      <CommandPalette />

    </div>
  )
}

export default Layout
